import {useQuery} from '@tanstack/react-query'
import {useAccessToken, useCommerceApi} from '@salesforce/commerce-sdk-react'
import CustomApi from './use-custom-api'

const useCountryDetails = (selectedCountry, options = {}) => {
    const {getTokenWhenReady} = useAccessToken()
    const customapi = new CustomApi()
    const api = useCommerceApi()
    const {proxy} = api.shopperExperience.clientConfig
    const {enabled = true} = options

    const fetchCountryDetails = async (selectedCountry) => {
        const token = await getTokenWhenReady()
        const apiName = 'country-details'
        const endpointPath = '/'
        const parameters = {
            c_selectedCountry: selectedCountry
        }
        const response = await customapi.get(token, apiName, endpointPath, parameters, proxy)

        return response
    }

    return useQuery({
        queryKey: ['use-country-details', selectedCountry],
        queryFn: () => fetchCountryDetails(selectedCountry),
        enabled: enabled && !!selectedCountry,
        keepPreviousData: true,
        staleTime: 24 * 60 * 60 * 1000, // 24hrs
        cacheTime: 24 * 60 * 60 * 1000, // 24hrs
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false
    })
}

export default useCountryDetails
